"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _autobahnUtilities = require("@gcc/autobahn-utilities");

var _MdCheckCircle = require("@react-icons/all-files/md/MdCheckCircle");

var _MdClose = require("@react-icons/all-files/md/MdClose");

var _MdErrorOutline = require("@react-icons/all-files/md/MdErrorOutline");

var _MdNotInterested = require("@react-icons/all-files/md/MdNotInterested");

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _Icon = _interopRequireDefault(require("../Icon/Icon.index"));

var _Alert = require("./Alert.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var icons = {
  ExclamationBox: 'exclamation-box',
  ExclamationTriangle: 'exclamation-triangle',
  CheckOutline: 'check-outline',
  MdCheckCircle: _MdCheckCircle.MdCheckCircle,
  MdErrorOutline: _MdErrorOutline.MdErrorOutline,
  MdNotInterested: _MdNotInterested.MdNotInterested
};

var Alert = function Alert(_ref) {
  var _theme$alert$icons$ty, _theme$alert$icons$ty2;

  var id = _ref.id,
      className = _ref.className,
      duration = _ref.duration,
      onClose = _ref.onClose,
      showIcon = _ref.showIcon,
      text = _ref.text,
      type = _ref.type,
      theme = _ref.theme,
      isHtml = _ref.isHtml;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      timedOut = _useState2[0],
      setTimedOut = _useState2[1];

  var shouldShowIcon = showIcon && ['success', 'warning', 'error'].includes(type);
  var IconVar = icons[(_theme$alert$icons$ty = theme.alert.icons[type]) === null || _theme$alert$icons$ty === void 0 ? void 0 : _theme$alert$icons$ty.vector];
  var iconColor = (_theme$alert$icons$ty2 = theme.alert.icons[type]) === null || _theme$alert$icons$ty2 === void 0 ? void 0 : _theme$alert$icons$ty2.color;

  if (typeof window !== 'undefined') {
    iconColor = window.getComputedStyle(document.documentElement, null).getPropertyValue("--".concat(iconColor));
  }

  var AlertIcon = (0, _react.useCallback)(function () {
    if (typeof IconVar === 'string') {
      return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: IconVar,
        size: "original",
        color: iconColor
      });
    }

    return /*#__PURE__*/_react["default"].createElement(IconVar, null);
  }, [IconVar, iconColor]);

  if (duration) {
    setTimeout(function () {
      setTimedOut(true);
      if (onClose) onClose();
    }, duration);
  }

  var displayText;

  if (isHtml) {
    displayText = /*#__PURE__*/_react["default"].createElement(_autobahnUtilities.DOMSanitizer, {
      element: "div"
    }, text);
  } else {
    displayText = text;
  }

  return timedOut ? null : /*#__PURE__*/_react["default"].createElement(_Alert.StyledAlert, {
    id: id,
    className: className,
    role: "presentation",
    type: type
  }, shouldShowIcon && /*#__PURE__*/_react["default"].createElement(_Alert.StyledIcon, {
    type: type
  }, IconVar && /*#__PURE__*/_react["default"].createElement(AlertIcon, null)), displayText, onClose && /*#__PURE__*/_react["default"].createElement(_Alert.StyledCloseIcon, {
    type: type
  }, /*#__PURE__*/_react["default"].createElement(_MdClose.MdClose, {
    onClick: onClose
  })));
};

Alert.defaultProps = {
  id: '',
  className: null,
  duration: null,
  showIcon: false,
  type: 'primary',
  onClose: undefined,
  isHtml: false
};
Alert.propTypes = {
  /** Custom Id that allows us to retrieve this element in the dom. */
  id: _propTypes.string,

  /** Custom class to be added to the container */
  className: _propTypes.string,

  /** How long to keep the alert displayed in milliseconds. null, 0, <0 all disable the timer. */
  duration: _propTypes.number,

  /** Sets if icon should be presented before the alert message */
  showIcon: _propTypes.bool,

  /** The text of the alert */
  text: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]).isRequired,

  /** Theme object. Passed automatically by the ThemeProvider high-order component. */
  theme: (0, _propTypes.shape)({}).isRequired,

  /** The type of alert. Possible values: */
  type: (0, _propTypes.oneOf)(['primary', 'secondary', 'success', 'warning', 'error']),

  /** The function to handle any higher level closing cleanup. Also causes a 'X' button to show. */
  onClose: _propTypes.func,

  /** Controls if the passed in text should be rendered as html or not. If true, it will render the html, if false it will render it as text. */
  isHtml: _propTypes.bool
};
Alert.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Alert",
  "props": {
    "id": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Custom Id that allows us to retrieve this element in the dom.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "Custom class to be added to the container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "duration": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "How long to keep the alert displayed in milliseconds. null, 0, <0 all disable the timer.",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "showIcon": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Sets if icon should be presented before the alert message",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "type": {
      "defaultValue": {
        "value": "'primary'",
        "computed": false
      },
      "description": "The type of alert. Possible values:",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }, {
          "value": "'success'",
          "computed": false
        }, {
          "value": "'warning'",
          "computed": false
        }, {
          "value": "'error'",
          "computed": false
        }]
      },
      "required": false
    },
    "onClose": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "The function to handle any higher level closing cleanup. Also causes a 'X' button to show.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "isHtml": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Controls if the passed in text should be rendered as html or not. If true, it will render the html, if false it will render it as text.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "text": {
      "description": "The text of the alert",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "string"
        }]
      },
      "required": true
    },
    "theme": {
      "description": "Theme object. Passed automatically by the ThemeProvider high-order component.",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};

var _default = (0, _styledComponents.withTheme)(Alert);

exports["default"] = _default;